import { ClientLoaderFunctionArgs, useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaDescriptorProps } from "@features/seo/utils/types";
import { Route } from "@route-types/Section/layouts/Supplements/Property/+types/PropertySupplementsPage";
import { fetchPropertySupplementsPageData } from "@routes/Section/layouts/Supplements/Property/PropertySupplementsPage.server";
import PropertySupplementsPageContent from "@routes/Section/layouts/Supplements/Property/PropertySupplementsPageContent";
import { SupplementsPageContext } from "@routes/Section/layouts/Supplements/utils/types";
import { fetchContext, ResponseType } from "@sphtech/web2-core/ssr";
import { createMetaTags } from "@sphtech/web2-seo-schema";
import { HttpStatusCode } from "axios";

const PropertySupplementsPage = (): React.ReactElement => {
  const context = useLoaderData<SupplementsPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <PropertySupplementsPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default PropertySupplementsPage;

export const loader = async () => await fetchPropertySupplementsPageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaDescriptorProps[] => {
  const context = loaderData as SupplementsPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return createMetaTags(data.metaTags);
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const result = (await fetchContext(args)) as {
    context?: SupplementsPageContext;
  };

  if (!result.context) return await args.serverLoader();

  return result.context;
};
